<template>
    <div class="tab-container" :id="id" :style="{height:height+'px'}">
        <el-image class="tab-item" :src="item" v-for="(item, index) in imgArr" :key="index" :preview-src-list="imgArr"></el-image>
    </div>
  </template>
  
  <script>
  var timer;
  export default {
    data() {
      return {
        //瀑布流数据
        pbList: [],
        colum:3,
        height:0,
      };
    },
    props:{
      id:{
        type:String,
        default:'tabContainer'
      },
      imgArr:[Array,String]
    },

    watch: {
      // 数据发生变化时重排
      imgArr(val) {
        this.imgArr = val
        const leng = val.length
        this.colum = leng > 2 ? 3 : leng 
        timer = setTimeout(() => {
        this.waterFall('#'+this.id, ".tab-item",this.colum); //实现瀑布流
        }, 20);     
      }  
    },

    async mounted() {
        const leng = this.imgArr.length
        this.colum = leng > 2 ? 3 : leng 
        await this.waterFall('#'+this.id, ".tab-item",this.colum); //实现瀑布流
        timer = setTimeout(() => {
        this.waterFall('#'+this.id, ".tab-item",this.colum); //实现瀑布流
        }, 20);
      // 窗口变化自适应布局
      window.onresize = () => {
        return (() => {
          this.waterFall('#'+this.id, ".tab-item",this.colum);
        })();
      };
    },
    destroyed () {
      clearInterval(timer)  
    },
    methods: {
      /**
       * @param { string } wrapIdName    容器id(或class)名称
       * @param { string } contentIdName 容器中内容项id(或class)名称
       * @param { number } column        容器中内容展示列数 手机的话建议改为2
       * @param { number } columnGap     容器中 列 间隔距离 默认为20
       * @param { number } rowGap        容器中 行 间隔距离 默认为20
       */
  
      //瀑布流方法：通过拿到dom循环，给每一个dom添加对应的定位位置排列出瀑布流布局。
      //通过判断列的高度，来把下一个盒子放在最短的地方补上
      waterFall(
        wrapIdName,
        contentIdName,
        columns = 3,
        columnGap = 20,
        rowGap = 20
      ) {
        // 获得内容可用宽度（去除滚动条宽度）
        const wrapContentWidth =
          document.querySelector(wrapIdName).offsetWidth - 8;
  
        // 间隔空白区域
        const whiteArea = (columns - 1) * columnGap;
  
        // 得到每列宽度(也即每项内容宽度)
        const contentWidth = parseInt((wrapContentWidth - whiteArea) / columns);
  
        // 得到内容项集合
        // const contentList = document.querySelectorAll(contentIdName);
        const contentList = document.querySelector(wrapIdName).childNodes
  
        // 成行内容项高度集合
        const lineConentHeightList = [];
  
        for (let i = 0; i < contentList.length; i++) {
          // 动态设置内容项宽度
          contentList[i].style.width = contentWidth + "px";
  
          // 获取内容项高度
          const height = contentList[i].clientHeight;
  
          if (i < columns) {
            // 第一行按序布局
            contentList[i].style.top = 0;
            contentList[i].style.left = contentWidth * i + columnGap * i + "px";
  
            // 将行高push到数组
            lineConentHeightList.push(height);
            this.height = Math.max(...lineConentHeightList)
          } else {
            // 其他行
            // 获取数组最小的高度 和 对应索引
            let minHeight = Math.min(...lineConentHeightList);
            let index = lineConentHeightList.findIndex(
              (listH) => listH === minHeight
            );
  
            contentList[i].style.top = minHeight + rowGap + "px";
            contentList[i].style.left = (contentWidth + columnGap) * index + "px";
  
            // 修改最小列的高度 最小列的高度 = 当前自己的高度 + 拼接过来的高度 + 行间距
            lineConentHeightList[index] += height + rowGap;
            this.height = Math.max(...lineConentHeightList)
          }
        }
      },
    },
  };
  </script>
  
  <style scoped>
  * {
    margin: 0;
    padding: 0;
  }
  /* 最外层大盒子 */
  .tab-container {
    position: relative;
    margin-top: 20px;
    /* height: 400px; */
    padding: 1px;
    /* overflow: scroll; */
    /* overflow-y: scroll; */
  }
  /* 每个小盒子 */
  .tab-container .tab-item {
    position: absolute;
    height: auto;
    /* border: 1px solid #ccc; */
    box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
    background: white;
    /* 元素不能中断显示 */
    break-inside: avoid;
    text-align: center;
    
  }
  /* 解决父元素塌陷问题 */
  .tab-container::after {
      content: '';
      display: block;
      clear: both;
   }

  .tab-container .tab-item img {
    width: 100%;
    height: auto;
  }
  
  </style>
  


// WEBPACK FOOTER //
// src/view/Panel/housework/components/WorkImgs.vue